<template>
  <div class="content">
    <div class="control_bar top">
      <div class="search">
        {{ title }}
      </div>
    </div>
    <div class="content_main">
      <div class="button_area margin_bottom">
        <input
          type="button"
          :value="cancelButton"
          class="cancel_button"
          @click="toMaintenance"
        />
      </div>
      <div class="table_area margin_bottom">
        <table rules="rows">
          <tr class="items_table">
            <th class="table_header">
              <label>{{ messageLabel }}</label>
            </th>
            <td class="table_contents">
              <div class="message_area">{{ maintenance.message }}</div>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ startLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ startDateTime }}</label>
            </td>
          </tr>
          <tr class="items_table">
            <th class="table_header">
              <label>{{ endLabel }}</label>
            </th>
            <td class="table_contents">
              <label>{{ endDateTime }}</label>
            </td>
          </tr>
        </table>
      </div>
      <div>{{ tenantListLabel }}</div>
      <div class="tenant_list table_area" v-if="!selectAllFlag">
        <table class="content_title" rules="rows">
          <tr class="items_table">
            <td class="table_contents">
              <label>{{ corporationNameLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantIdLabel }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenantNameLabel }}</label>
            </td>
          </tr>
        </table>

        <table class="items_table" rules="rows">
          <tr
            class="item_table_row"
            v-for="tenant in companyList"
            :key="tenant.companyId"
          >
            <td class="table_contents">
              <label>{{ tenant.corporationName }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyId }}</label>
            </td>
            <td class="table_contents">
              <label>{{ tenant.companyName }}</label>
            </td>
          </tr>
        </table>
      </div>

      <div class="indent" v-if="selectAllFlag">
        {{ selectAllLabel }}
      </div>

      <div class="bottom" v-if="!selectAllFlag">
        <pagination
          v-model="page"
          :records="total"
          :per-page="pageSize"
          :options="{texts: {count: '{from} - {to}/{count}件'}, chunk: 5}"
          @paginate="setCorporations()"
        >
        </pagination>
      </div>
    </div>
    <div class="complete_modal_window" v-if="showFailureModal">
      <completeModalWindow :question="failureWord" @close="close">
      </completeModalWindow>
    </div>
    <div class="loading_modal_window" v-if="showloadingModal">
      <loadingModalWindow @close="close"> </loadingModalWindow>
    </div>
  </div>
</template>

<script>
import Pagination from 'vue-pagination-2'
import datepicker from 'vue-flatpickr-component'
import loadingModalWindow from '../../../modalWindow/loadingModalWindow.vue'

export default {
  data() {
    return {
      title: 'メンテナンス詳細',
      startLabel: '開始',
      endLabel: '終了',
      messageLabel: 'メッセージ',
      tenantListLabel: 'メンテナンス実施テナント',
      selectAllLabel:
        '全体通知 ※個別のチェックに関係なく全体に通知します。後から作成されたテナントにも通知されます。',
      corporationNameLabel: '法人名',
      tenantIdLabel: 'テナントID',
      tenantNameLabel: 'テナント名',
      cancelButton: '戻る',
      failureWord: '',
      showFailureModal: false,
      showloadingModal: false,
      toBackList: true,
      pageSize: 20,
      page: 1,
      prevTotal: 0,
      companyList: []
    }
  },
  computed: {
    sysErrorMsg() {
      return this.$store.state.error.sysErrorMsg
    },
    total() {
      if (this.$store.state.maintenance.maintenance.companyList) {
        if (
          (this.page - 1) * this.pageSize <=
          this.$store.state.maintenance.maintenance.companyList.length
        ) {
          return this.$store.state.maintenance.maintenance.companyList.length
        }
      }
      return this.prevTotal
    },
    isOverPage() {
      return (
        (this.page - 1) * this.pageSize >=
        this.$store.state.maintenance.maintenance.companyList.length
      )
    },
    lastPage() {
      const last = Math.ceil(
        this.$store.state.maintenance.maintenance.companyList.length /
          this.pageSize
      )
      return last === 0 ? 1 : last
    },
    maintenance() {
      return this.$store.state.maintenance.maintenance
    },
    startDateTime() {
      var s = new Date(this.$store.state.maintenance.maintenance.startDateTime)
      if (s) {
        var startDateTime =
          s.getFullYear() +
          '/' +
          this.padZero(s.getMonth() + 1) +
          '/' +
          this.padZero(s.getDate()) +
          '  ' +
          this.padZero(s.getHours()) +
          ':' +
          this.padZero(s.getMinutes()) +
          ':' +
          this.padZero(s.getSeconds())
        return startDateTime
      }
      return ''
    },
    endDateTime() {
      var e = new Date(this.$store.state.maintenance.maintenance.endDateTime)
      if (e) {
        var endDateTime =
          e.getFullYear() +
          '/' +
          this.padZero(e.getMonth() + 1) +
          '/' +
          this.padZero(e.getDate()) +
          '  ' +
          this.padZero(e.getHours()) +
          ':' +
          this.padZero(e.getMinutes()) +
          ':' +
          this.padZero(e.getSeconds())
        return endDateTime
      }
      return ''
    }
  },
  components: {
    datepicker,
    loadingModalWindow,
    Pagination
  },
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.updateWindowHeight()
    this.showloadingModal = true
    try {
      await this.$store.dispatch('maintenance/setMaintenanceDetail', {
        maintenanceId: this.$store.state.maintenance.updateData.maintenanceId
      })
      this.toBackList = false
      this.companyList = this.maintenance.companyList.slice(0, 20)
    } catch (error) {
      let eventNumber = this.$store.state.error.sysErrorCode.sysErrorCode_650005
      this.createErrorMessage(error, eventNumber, 'MSGCRD0112')
      this.showFailureModal = true
    }
    if (this.maintenance.allFlag === true) {
      this.selectAllFlag = true
    }
    this.showloadingModal = false
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // ウィンドウサイズ変更時にリアルタイムでウィンドウサイズの値を更新
      this.updateWindowHeight()
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    },
    setCorporations() {
      this.companyList = this.maintenance.companyList.slice(
        this.pageSize * (this.page - 1),
        this.pageSize * this.page
      )
      if (this.isOverPage) {
        this.page = this.lastPage
      }
    },
    toMaintenance() {
      this.$router.push('/master/maintenance')
    },
    close() {
      this.showFailureModal = false
      if (this.toBackList) {
        this.$router.push('/master/maintenance')
      }
    },
    createErrorMessage(error, eventNumber, errorNumber) {
      if (
        error.response &&
        error.response.data &&
        error.response.data.header &&
        error.response.data.header.message
      ) {
        let errorMessage = error.response.data.header.message
        if (!errorMessage.indexOf('MSGCRD')) {
          this.failureWord =
            this.sysErrorMsg[errorMessage].name +
            this.sysErrorMsg[errorMessage].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        } else {
          this.failureWord =
            this.sysErrorMsg[errorNumber].name +
            this.sysErrorMsg[errorNumber].value +
            'エラーコード：{' +
            eventNumber +
            '}'
        }
      } else {
        this.failureWord =
          this.sysErrorMsg.MSGCRD0001.name +
          this.sysErrorMsg.MSGCRD0001.value +
          'エラーコード：{' +
          eventNumber +
          '}'
      }
    },
    padZero(num) {
      return num < 10 ? '0' + num : num
    }
  }
}
</script>
<style scoped>
.button_area {
  display: flex;
  justify-content: end;
}
.control_bar {
  background-color: #bbffff;
}
.content,
.bottom {
  width: calc(100% - 262px);
}
.content_title {
  width: 100%;
  background-color: #ddffff;
}
.content_main {
  height: calc(100% - 110px);
  position: relative;
  background-color: #fff;
  padding: 26px 32px;
  overflow-y: scroll;
}
.table_area {
  border: 1px solid #a6e3e0;
}
table {
  width: 100%;
  table-layout: fixed;
}
.table_header {
  background-color: #ddffff;
  width: 20%;
}
.tenant_list .table_contents {
  width: 30%;
}
.table_contents {
  width: 80%;
}
.bottom {
  height: 53px;
  width: 100%;
  border-top: none;
  background-color: #ddffff;
  position: sticky;
  bottom: auto;
}
.message_area {
  word-wrap: break-word;
  white-space: pre-wrap;
}
</style>



// WEBPACK FOOTER //
// src/components/masterPanel/masterView/maintenance/maintenanceDetail.vue